import React from "react";

export function Badge({ tone = "neutral", className = "", children, ...props }) {
  return (
    <span className={`np-badge np-status-pill--${tone} ${className}`.trim()} {...props}>
      {children}
    </span>
  );
}

export function Alert({ tone = "neutral", className = "", children, ...props }) {
  const toneClass = tone === "danger" ? "np-alert--danger" : `np-alert--${tone}`;
  return (
    <div className={`np-alert ${toneClass} ${className}`.trim()} role="alert" {...props}>
      {children}
    </div>
  );
}
